export const VERIFY_EMAIL_ROUTE = {
  TITLE: 'Verify Email',
  ABSOLUTE_PATH: '/verify-email',
  EXACT_PATH: '/verify-email',
};
